import React, {useLayoutEffect, useMemo, useState} from 'react';
import SignIn from "./pages/SignIn";
import ArgosId from "./pages/ArgosId";
import {IUser} from "./types/type";
import i18n from "i18next";

interface IApp {
    project : string
    chains : string[] | string
    buttonStyle : object | string
    env : "live" | "dev"
}


const App: React.FC<IApp> =
    ({
         project,
         chains,
         buttonStyle,
         env
     }) => {


    useLayoutEffect(() => {
        const locale = navigator.language;
            i18n.changeLanguage('en-US')
        if (locale === 'ko-KR') {
            i18n.changeLanguage(locale)
        } else if (locale === 'en-US') {
            i18n.changeLanguage(locale)
        }
    },[])


    const projectId = useMemo(() => {
        return project
    },[])


    const [user, setUser] = useState<IUser>({
        objectId : "",
        id : "",
        className : "",
    })
    const [alreadyUserId , setAlreadyUserId] = useState<boolean>(false);
    const [firstVisit , setFirstVisit] = useState<boolean>(false);





    if (user.objectId && user.id) {
        return (
            <ArgosId
                alreadyUserId={alreadyUserId}
                user={user}
                setUser={setUser}
                firstVisit={firstVisit}
                setFirstVisit={setFirstVisit}
                projectId={projectId}
                chains={chains}
                env={env}
            />
        )
    }

    return (
        <SignIn
            setAlreadyUserId={setAlreadyUserId}
            setUser={setUser}
            setFirstVisit={setFirstVisit}
            buttonStyle={buttonStyle}
            env={env}
        />
    )


}


export default App;